import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Education = () => {
  const { t } = useLanguage();
  const education = t('education');
  const certifications = t('certifications');
  const languages = t('languages');

  return (
    <section className="section">
      <div className="wrap split">
        <h2 className="split__label">{t('educationTitle')}</h2>
        <div>
          <div className="entries">
            {education.map((edu) => (
              <article key={`${edu.year}-${edu.degree}`} className="entry">
                <p className="entry__when">{edu.year}</p>
                <div>
                  <h3 className="entry__title">{edu.degree}</h3>
                  <p className="entry__org">{edu.school}</p>
                  <ul className="entry__points">
                    {edu.bullets.map((b) => (
                      <li key={b}>{b}</li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>

          <div className="pair-grid">
            <div>
              <h3 className="subhead subhead--flush">{t('certificationsTitle')}</h3>
              <ul className="rule-list rule-list--single">
                {certifications.map((cert) => (
                  <li key={cert}>{cert}</li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="subhead subhead--flush">{t('languagesTitle')}</h3>
              <ul className="language-list">
                {languages.map((lang) => (
                  <li key={lang.name}>
                    {lang.name}
                    <span>{lang.level}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
